<template>
  <div>
    <footer class="bg1">
      <div class="container p-t-15 p-b-40">
        <div class="row">
          <div class="col-sm-6 col-md-4 p-t-50">
            <h4 class="txt13 m-b-33" style = "margin-bottom: 38px;">{{ $t("column.findUs") }}</h4>
            <ul class="m-b-70">
              <li class="txt14 m-b-14">
                <i class="fa fa-map-marker fs-16 dis-inline-block size19" aria-hidden="true"></i>
                {{ $t("footer.address") }}
              </li>
              <li class="txt14 m-b-14">
                <i class="fa fa-phone fs-16 dis-inline-block size19" aria-hidden="true"></i>
                (+886) 974 006 188
              </li>
              <li class="txt14 m-b-14">
                <i class="fa fa-envelope fs-13 dis-inline-block size19" aria-hidden="true"></i>
                  <a href="mailto:ourbest100@yahoo.com.tw">聯絡我們</a>
              </li>
            </ul>
          </div>

          <div class="col-sm-6 col-md-4 p-t-50">
            <!-- - -->
            <h4 class="txt13 m-b-38">FACEBOOK</h4>
            <iframe
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fhaihostel%2F&tabs=timeline&width=340&height=250&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
              width="340"
              height="250"
              style="border:none;overflow:hidden"
              scrolling="no"
              frameborder="0"
              allowtransparency="true"
              allow="encrypted-media"
            ></iframe>
          </div>

          <div class="col-sm-6 col-md-4 p-t-50">
            <h4 class="txt13 m-b-33" style = "margin-bottom: 38px;">
                <router-link to="/privacyPolicy">privacy policy</router-link>
            </h4>
            <div class="gallery-sidebar t-center p-l-60 p-r-60 p-b-40">
        <!-- <h4 class="txt20 m-b-33-instagram-footer" style = "margin-bottom:38px;">INSTAGRAM</h4>
        <div class="wrap-gallery-sidebar flex-w">
          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[0].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[0].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[1].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[1].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[2].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[2].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[3].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[3].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[4].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[4].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[5].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[5].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[6].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[6].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[7].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[7].images.standard_resolution.url" alt="GALLERY">
          </a>

          <a
            class="item-gallery-sidebar wrap-pic-w"
            v-bind:href="this.result[8].images.low_resolution.url"
            data-lightbox="gallery-footer"
          >
            <img v-bind:src="this.result[8].images.standard_resolution.url" alt="GALLERY">
          </a>
        </div> -->
      </div>

          </div>

        </div>
      </div>
      <div class="end-footer bg2">
        <div class="container">
          <div class="flex-sb-m flex-w p-t-22 p-b-22">
            <div class="p-t-5 p-b-5">
              <a href="https://www.facebook.com/haihostel/" target="_blank" class="fs-15 c-white">
                <i class="fa fa-facebook m-l-18" aria-hidden="true"></i>
              </a>
              <a href="https://www.instagram.com/pataw_hostel/" target="_blank" class="fs-15 c-white">
                <i class="fa fa-instagram m-l-18" aria-hidden="true"></i>
              </a>
            </div>
            <div class="txt17 p-r-20 p-t-5 p-b-5">
              Copyright &copy; 2019 Eslitec power by theme Colorlib All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
    <div class="btn-back-to-top bg0-hov" id="myBtn">
      <span class="symbol-btn-back-to-top">
        <i class="fa fa-angle-double-up" aria-hidden="true"></i>
      </span>
    </div>
    <div id="dropDownSelect1"></div>
    <div class="modal fade" id="modal-video-01" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document" data-dismiss="modal">
        <div class="close-mo-video-01 trans-0-4" data-dismiss="modal" aria-label="Close">&times;</div>

        <div class="wrap-video-mo-01">
          <div class="w-full wrap-pic-w op-0-0">
            <img src="/static/images/icons/video-16-9.jpg" alt="IMG">
          </div>
          <div class="video-mo-01">
            <!-- <iframe
              src="https://www.youtube.com/embed/5k1hSu2gdKE?rel=0&amp;showinfo=0"
              allowfullscreen
            ></iframe> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped >
.txt20.m-b-33-instagram-footer{
  color:white;
}
@media (max-width: 414px) {
.gallery-sidebar.t-center.p-l-60.p-r-60.p-b-40{
  display: none;
}
}
</style>
<script >
export default {
  name: "Footer",
  data() {
    return {
      result: 0
    };
  },
  created() {
    //
    //var getAuthUrl =
    //  "https://api.instagram.com/oauth/authorize/?client_id=	e2762c5ab4784e3a937716fa6e3d45da&redirect_uri=http://localhost:8081&response_type=token";
    // var accessToken =
    //   "?access_token=1505778998.16061ea.135c5f0f37ca4b5aac1470e8feb9d33f";
    // var xhr = new XMLHttpRequest();
    // xhr.addEventListener("readystatechange", function() {
    //   if (this.readyState === 4) {
    //     var response = JSON.parse(this.responseText);
    //     this.result = response;
    //   }
    // });
    // xhr.open(
    //   "GET",
    //   "https://api.instagram.com/v1/users/self/media/recent/" + accessToken,
    //   false
    // );
    // xhr.send();
    // this.result = JSON.parse(xhr.response);
    // this.result = this.result.data;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue